import { Card, CardContent, Box, Skeleton } from '@mui/material';

export function TicketCardSkeleton() {
  return (
    <Card sx={{ mb: 2 }}>
      <CardContent>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
          <Box sx={{ flex: 1 }}>
            <Skeleton variant="text" width="60%" height={32} />
            <Skeleton variant="text" width="40%" height={20} />
          </Box>
          <Skeleton variant="rectangular" width={80} height={24} sx={{ borderRadius: 1 }} />
        </Box>

        <Box sx={{ display: 'flex', gap: 3, mb: 2 }}>
          <Box>
            <Skeleton variant="text" width={60} height={20} />
            <Skeleton variant="text" width={40} height={28} />
          </Box>
          <Box>
            <Skeleton variant="text" width={80} height={20} />
            <Skeleton variant="text" width={40} height={28} />
          </Box>
        </Box>

        <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end' }}>
          <Skeleton variant="rectangular" width={60} height={32} sx={{ borderRadius: 1 }} />
          <Skeleton variant="rectangular" width={60} height={32} sx={{ borderRadius: 1 }} />
          <Skeleton variant="rectangular" width={60} height={32} sx={{ borderRadius: 1 }} />
        </Box>
      </CardContent>
    </Card>
  );
}
